import { FormCompleteView } from "@/features/diaries/components/FormCompleteView";
import { diaryByIdQueryOptions } from "@/features/diaries/api";
import { createFileRoute } from "@tanstack/react-router";

const EntryComplete = () => {
    const { diaryId, entryId, trackerId } = Route.useParams();
    return <FormCompleteView diaryId={diaryId} entryId={entryId} trackerId={trackerId} />;
};

export const Route = createFileRoute("/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete")({
    component: EntryComplete,
    loader: async ({ params, context }) => {
        await context.queryClient.fetchQuery(diaryByIdQueryOptions(params.diaryId));
        return {};
    },
});
